import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
// import printer settings   start
import { PrinterSettings, PrinterSettingsData } from '../../../../../@core/interfaces/masters/printersettings';
import { imageatch_detData } from '../../../../../@core/interfaces/masters/imageatch_det';
import { PrintServiceService } from '../../service/print-service.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

// import ps end
@Component({
  selector: 'ngx-printing-list',
  templateUrl: './printing-list.component.html',
  styleUrls: ['./printing-list.component.scss']
})
export class PrintingListComponent implements OnInit {
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");

  @Input() title;
  @Input() pageName;
  @Input() tableContent;

  // printer settings variable declare start ***********  Raja
  styleUrl = "/assets/css/print.css,/assets/css/a4landscape.css";
  srcname = "../.././../../assets/images/white.png";
  @Output() psDetails: PrinterSettings;
  // printer settings variable declare end ***********  Raja
  protected readonly unsubscribe$ = new Subject<void>();

  @Output() psDetail = new EventEmitter();
  @Output() printEvent = new EventEmitter();

  constructor(private iatchSrvc: imageatch_detData,
    protected psSrvc: PrinterSettingsData,
    private printService: PrintServiceService,
    @Inject(DOCUMENT) private document: any,) { }

  ngOnInit(): void {
    if(true){
      this.loadPSF();
      this.loadImg();
    }
  }


  // load printer settings  ***********  Raja
  loadPSF() {
    // call api load printer settings
    this.psSrvc.list(this.tenantId + "/" + this.branchId + "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

     // //console.log("*************** data ", data)
      var ps = data.filter(ps => ps.pageSetupFor == this.pageName)
     // //console.log("Ps ", ps, " = ", this.pageName);

      // set printer settings data
      if (ps.length > 0) {
        this.psDetails = ps[0];
        this.psDetail.emit(this.psDetails);

        // dynamic set style url based on papper size
        this.styleUrl = "/assets/css/print.css,/assets/css/" + (this.psDetails.paperSize).toLowerCase() + (this.psDetails.orientation).toLowerCase() + ".css";
        // set position header and footer start
        this.psDetails.topHeaderLogoPosition = "center " + this.psDetails.topHeaderLogoPosition;
        this.psDetails.topHeaderPosition = "center " + this.psDetails.topHeaderPosition;
        this.psDetails.reportHeaderPlacement = "center " + this.psDetails.reportHeaderPlacement;
        this.psDetails.topHeaderLogoRequired = this.psDetails.topHeaderLogoRequired == "1" ? true : false;
        this.psDetails.topHeaderRequired = this.psDetails.topHeaderRequired == "1" ? true : false;
        this.psDetails.bottomFooterLogoPosition = "center " + this.psDetails.bottomFooterLogoPosition;
        this.psDetails.bottomFooterPosition = "center " + this.psDetails.bottomFooterPosition;
        this.psDetails.bottomFooterLogoRequired = this.psDetails.bottomFooterLogoRequired == "1" ? true : false;
        this.psDetails.bottomFooterRequired = this.psDetails.bottomFooterRequired == "1" ? true : false;
        // end 
       // //console.log(data, " ==== ", ps, " +++++ ", this.psDetails);
      } else {
        this.psDetails=this.printService.onGetPrinterSettings();

        this.psDetails.reportHeaderPlacement = "center center";

        this.printService.listname=this.pageName;
        this.printService.listPrint=this.psDetails;

      }
    }, (error) => {
    }, () => {
      if (this.psDetails?.pageTitle == null) {
        this.psDetails.pageTitle = this.title;
      }
      if(this.psDetails?.pageSetupFor == null){
        this.psDetails.pageSetupFor=this.title;
      }
      //// ////console.log("*************** ++++++++++++++++")
    });
   // //console.log("Ps = ", this.psDetails);
  }

  // load tenant img  ***********  Raja
  loadImg() {

    this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/logo`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      ////// ////console.log("api 1 = ",data)
      this.srcname = "../.././../../assets/images/white.png"
      this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, data[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
        ////// ////console.log("api 2 = ",downloaddata)
        this.srcname = 'data:image/jpeg;base64,' + downloaddata;
      }, (error) => {

      }, () => {

      });

    }, (error) => {

    }, () => {

    });

  }
  getContent() {
    this.printEvent.emit({"Print":this.psDetails})
  }
  async printDiv() {
    await this.sleep(500);
    // ////console.log("Test",document.getElementById('print-section').innerHTML)
    this.printService.printPage(document.getElementById('print-section').innerHTML, this.psDetails)

  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
